export default "__VITE_ASSET__7ce4f6cd__"